package com.loyola.acessoescola.ui

import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.toComposeImageBitmap
import com.loyola.acessoescola.services.quintadb.InvalidImageURIException
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.suspendCancellableCoroutine
import org.jetbrains.skia.Image
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Int8Array
import org.khronos.webgl.Uint8Array
import org.w3c.dom.CanvasRenderingContext2D
import org.w3c.dom.HTMLCanvasElement
import org.w3c.dom.HTMLImageElement
import org.w3c.fetch.Response
import org.w3c.files.Blob
import org.w3c.files.FileReader
import kotlin.coroutines.resume
import kotlin.js.Promise
import kotlin.math.PI

actual suspend fun loadImageBitMap(uri: String): ImageBitmap? {
    return try {

        val skiaImage = Image.makeFromEncoded(readBytesFromURI(uri) ?: throw InvalidImageURIException(uri))
        skiaImage.toComposeImageBitmap()
    } catch (e: Exception){
        console.error("Error loading image", e)
        null
    }
}

actual suspend fun readBytesFromURI(uri: String): ByteArray? {
    val response: Response = window.fetch(uri).await()
    val buffer = response.arrayBuffer().await()
    val orientation = Exifr.orientation(buffer).await()
    val rotation = when (orientation) {
        //3 -> 180
        //6 -> 90
        //8 -> 270
        else -> 0
    }
    console.log("rotation: $rotation, orientation: $orientation")
    val rotatedBytes = rotateBytes(
        bytes = Int8Array(buffer).unsafeCast<ByteArray>(),
        rotation = rotation
    )
    return rotatedBytes
}


private suspend fun rotateBytes(
    bytes: ByteArray,
    rotation: Int
): ByteArray {

    val uint8 = Uint8Array(bytes.size)

    for (i in bytes.indices) {
        uint8.asDynamic()[i] = bytes[i].toInt() and 0xFF
    }


    val blob = Blob(arrayOf(uint8))

    val url = js("URL.createObjectURL(blob)") as String

    val image = document
        .createElement("img")
        .unsafeCast<HTMLImageElement>()

    suspendCancellableCoroutine<Unit> { continuation ->
        image.onload = {
            continuation.resume(Unit)
        }

        image.src = url
    }

    val canvas = document
        .createElement("canvas")
        .unsafeCast<HTMLCanvasElement>()

    val context = canvas
        .getContext("2d")
        .unsafeCast<CanvasRenderingContext2D>()

    if (rotation == 90 || rotation == 270) {
        canvas.width = image.naturalHeight
        canvas.height = image.naturalWidth
    } else {
        canvas.width = image.naturalWidth
        canvas.height = image.naturalHeight
    }

    when (rotation) {
        0 -> {
            context.translate(
                0.0,
                0.0
            )
            context.rotate(0.0)
        }

//        90 -> {
//            context.translate(
//                canvas.width.toDouble(),
//                0.0
//            )
//            context.rotate(PI / 2)
//        }
//
//        180 -> {
//            context.translate(
//                canvas.width.toDouble(),
//                canvas.height.toDouble()
//            )
//            context.rotate(PI)
//        }
//
//        270 -> {
//            context.translate(
//                0.0,
//                canvas.height.toDouble()
//            )
//            context.rotate(-PI / 2)
//        }
    }

    context.drawImage(image, 0.0, 0.0)

    val rotatedBlob = suspendCancellableCoroutine<Blob> { continuation ->
        canvas.toBlob(
            { blob ->
                continuation.resume(blob!!)
            },
            "image/jpeg",
            0.9
        )
    }

    val arrayBuffer = suspendCancellableCoroutine<dynamic> { continuation ->

        val reader = FileReader()

        reader.onload = {
            continuation.resume(reader.result)
        }

        reader.readAsArrayBuffer(rotatedBlob)
    }

    val rotated = Int8Array(
        arrayBuffer.unsafeCast<ArrayBuffer>()
    )

    return ByteArray(rotated.length) { index ->
        rotated.asDynamic()[index] as Byte
    }
}


@JsModule("exifr")
@JsNonModule
external object Exifr {
    fun orientation(file: dynamic): Promise<Int?>
}